import React from 'react';
import { Box, Typography, Paper, Stack, Switch, FormControlLabel } from '@mui/material';

const SettingsPage: React.FC = () => (
  <Box>
    <Typography variant="h4" fontWeight={600} mb={3}>
      Workspace Settings
    </Typography>
    <Stack spacing={2}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Notifications
        </Typography>
        <FormControlLabel control={<Switch defaultChecked />} label="Product updates" />
        <FormControlLabel control={<Switch />} label="Weekly summaries" />
      </Paper>
      <Paper sx={{ p: 3 }}>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Access control
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Configure your role-based access policies here when ready.
        </Typography>
      </Paper>
    </Stack>
  </Box>
);

export default SettingsPage;
